import Section from 'layouts/Section/Section';

import CollapseSection from 'components/CollapseSection/CollapseSection';
import Title from 'components/Title/Title';

import styles from './PrivacyPolicy.module.scss';
import items from './items';

const PrivacyPolicy = () => {
  return (
    <Section>
      <p className={styles.lastRevision}>
        Updated version 2.2 - Date of Last Revision: May 2nd, 2025
      </p>
      <Title title="Privacy Notice" textAlign="left"></Title>
      {items.map(({ title, summary, details }, index) => (
        <CollapseSection
          title={title || ''}
          summary={summary}
          details={details}
          index={index}
        />
      ))}
    </Section>
  );
};

export default PrivacyPolicy;
